import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-task-filter',
  templateUrl: './task-filter.component.html',
  styleUrls: ['./task-filter.component.css']
})
export class TaskFilterComponent implements OnInit {

  usersList: any= []
  status = ""
  userId = ""
  date1:any
  date2: any
  filteredData: any= []
  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  first: number = 0;
  isLoading: any = false

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getUsersWithoutCustomers()
    this.date2 = formatDate(new Date(), 'yyyy-MM-dd', 'en-US')
    console.log(new Date(this.date2).getTime())
    this.date1 = new Date()
    this.date1.setDate(this.date1.getDate()-30);
    this.date1 = formatDate(this.date1, 'yyyy-MM-dd', 'en-US')
    console.log(this.date1)

  }

  getUsersWithoutCustomers(){
    this.generic_service.getUsersWithoutCustomers().subscribe(
      (res:any)=>{
        this.usersList = res.response;
      }
    )
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    console.log(event);

    this.getFilteredData(this.pageNumber,this.totalRecords)

  }

  getFilteredData(pageNumber:any,totalRecords:any){
    this.isLoading = true

    let body = {
      "userId": Number(this.userId),
      "status": String(this.status),
      "date1": new Date(this.date1).getTime(),
      "date2": new Date(this.date2).getTime()
    }
    console.log(body)
    this.generic_service.taskFilterByStatusAndUserIdAndDates(body,pageNumber,totalRecords).subscribe(
      (response:any)=>{
        console.log(response)
        this.filteredData = []
        this.filteredData = response.response.taskList
        this.totalRecords = response.response.totalRecords
        this.isLoading = false
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }
}